import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { UPLOAD_RULES } from "src/app/shared/upload/upload-policy";
import { ActivatedRoute } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { Message, MessageService } from "primeng/api";
import { Table } from "primeng/table";
import { Project } from "src/app/model/form/project";
import { Image } from "src/app/model/Image";
import { Load } from "src/app/model/mockup/load-mockup";
import { Share } from "src/app/model/share";
import { AccountService } from "src/app/service/account.service";
import { ApplicationService } from "src/app/service/application.service";
import { ProjectService } from "src/app/service/project.service";
import { CustomValidator } from "src/shared/custom-validator";
import { CreateProjectPostReq } from "../../../model/request/create-project-post-req";
import { CreProVcuPostReq } from "../../../model/request/cre-pro-vcu-post-req";
import { CreProUserSharingPostReq } from "../../../model/request/cre-pro-user-sharing-post-req";
import { UpdateProjectPutReq } from "../../../model/request/update-project-put-req";
import { UpdProUserSharingPutReq } from "../../../model/request/upd-pro-user-sharing-put-req";
import { Item } from "src/app/model/Item";
import { FileService } from "src/app/service/file.service";
import { HttpResponse } from "@angular/common/http";
import { CategoryService } from "../../../service/category.service";
import { Vcu } from "../../../model/form/vcu";
import { Equipment } from "src/app/model/equipment";
import { SharingItem } from "src/app/model/sharingItem";
import { SharingProjectTypeService } from "src/app/service/sharingProjectType.service";
import { CarsManufactureModel } from "src/app/model/cars-manufacture";
import { CarsManufacture } from "src/app/service/carsManufacture.service";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";
import { AuthService } from "src/app/service/auth.service";
import { Subject } from "rxjs";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: "app-register-project",
  templateUrl: "./register-project.component.html",
  styleUrl: "./register-project.component.css",
})
export class RegisterProjectComponent implements OnInit, OnChanges {
  public form!: FormGroup;

  @Input()
  showDialog: boolean = true;

  @Input()
  editMode: boolean = false;

  @Input()
  project: Project | null = null;

  @Output() closeDialog = new EventEmitter<any>();

  /** Dispara SOMENTE quando o projeto é salvo de fato — os pais recarregam aqui (não no closeDialog). */
  @Output() saved = new EventEmitter<string>();

  @ViewChild("dtShare") dtShare: Table | undefined;

  @ViewChild("fileInput") fileInput: ElementRef<HTMLInputElement> | undefined;

  loadingShare: boolean = false;

  primaryImage: any;

  dialogHeader: string = "";
  activeStep = 0;
  steps: StepDef[] = [];
  isDragging = false;
  /** Opções de referência (estáticas) são carregadas só uma vez por instância — evita recarregar tudo a cada abertura. */
  private optionsLoaded = false;
  applicationOptions: Item[] = [];
  sharingProjectTypeOptions: Item[] = [];
  carsManufactureOptions: CarsManufactureModel[] = [];
  carsModelOptions: CarsManufactureModel[] = [];
  selectedCarManufacturer: any;
  selectedCarModel: any;
  dealerOptions: object[];
  vcusOptions: GenericEquipment[] = [];
  categoriesOptions: GenericEquipment[];
  productsOptions: GenericEquipment[][] = [];
  message: Message[];
  loadingImage: boolean;
  idAux: number = 0;
  userID: string = "";
  projectID: string = "";
  selectedFiles: File[] | null = null;
  isLoadingEquipments: boolean = false;
  isClicked: boolean = false;
  isOthers: boolean = false;

  loadingUpload: boolean = false;
  loadinFinishButton: boolean = false;
  /** Criação de projeto sob demanda em andamento — trava o botão "Próximo". */
  creatingProject: boolean = false;
  /** Promise da criação em voo: reaproveitada para evitar projetos duplicados. */
  private creatingProjectPromise: Promise<boolean> | null = null;

  filtredManufacturer: any[] = [];
  filtredModel: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private translocoService: TranslocoService,
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService,
    private applicationService: ApplicationService,
    private sharingProjectTypeService: SharingProjectTypeService,
    private projectService: ProjectService,
    private fileService: FileService,
    private categoryService: CategoryService,
    private messageService: MessageService,
    private carManufactureService: CarsManufacture,
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {
    // this.applicationOptions = Load.APPLICATION;
    this.dealerOptions = Load.DEALER;
    //TODO gerar ID unico em comum para os 3 dropdowns
    // e retornar apenas 2 IDs, da VCU e do equipamento
    // ignorar a Categoria, usada apenas para filtro
    // porque assim fica mais facil de identificar o objeto e realizar o vinculo
    this.vcusOptions = [];
    this.categoriesOptions = [];
    this.productsOptions = [];
    this.message = [];
    this.loadingImage = false;
    if (this.project && this.project.images.length > 0)
      this.project.primaryImage = this.project?.images[0];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.project?.currentValue) {
      this.project = changes.project.currentValue;

      if (this.project) {
        this.project.application = this.applicationOptions.filter((item) =>
          this.project?.application?.some((app) => app.id === item.id)
        );
      }
      this.sharingProjectTypeOptions
        .filter(
          (item) =>
            this.project && item.id === this.project.sharingProjectType?.id
        )
        .map((it) =>
          this.project ? (this.project.sharingProjectType = it) : null
        );

      if (this.project) {
        this.createForm(this.project);
      }
    }
    if (
      changes.showDialog !== undefined &&
      changes.showDialog?.currentValue !== changes.showDialog?.previousValue
    ) {
      if (changes.showDialog?.currentValue) {
        // Modal está abrindo - inicializa estado
        this.initializeModalState();
        this.openingDialog();
      }
    }
  }

  ngOnInit() {
    this.userID = this.authService.getUserInformations();
    this.initializeModalState();
  }

  initializeModalState() {
    this.messageService.clear();
    this.isClicked = false;
    this.loadingUpload = false;
    this.loadinFinishButton = false;
    this.creatingProject = false;
    this.creatingProjectPromise = null;
    
    if (!this.project || !this.editMode) {
      this.project = new Project();
      this.createForm(this.project);
    }
    
    this.activeStep = 0;

    this.translocoService
      .selectTranslateObject("project.register.steps")
      .subscribe((value: { label: string }[]) => {
        const labels = (value ?? []).map((s) => s.label);
        this.steps = this.buildSteps(labels);
      })
      .unsubscribe();
  }

  /** Monta os passos conforme o modo: criar = 4 passos; editar = 3 (sem "Compartilhar"). */
  private buildSteps(labels: string[]): StepDef[] {
    const all: StepDef[] = [
      {
        key: "basic",
        label: labels[0] ?? "",
        fieldKeys: [
          "name",
          "application",
          "sharingProjectType",
          "manufacturer",
          "model",
          "yearDate",
          "tags",
          "detail",
          "favorite",
        ],
      },
      { key: "equipment", label: labels[1] ?? "", fieldKeys: ["genericEquipments"] },
      { key: "images", label: labels[2] ?? "", fieldKeys: ["images", "primaryImage"] },
      // 'email' é apenas um campo auxiliar (validado em addShare); compartilhar é opcional.
      { key: "share", label: labels[3] ?? "", fieldKeys: ["sharedWith"] },
    ];
    return this.editMode ? all.slice(0, 3) : all;
  }

  get isFirstStep(): boolean {
    return this.activeStep === 0;
  }
  get isLastStep(): boolean {
    return this.activeStep === this.steps.length - 1;
  }
  get currentStep(): StepDef | undefined {
    return this.steps[this.activeStep];
  }

  /** Habilita "Finalizar" só quando todos os campos obrigatórios estão válidos. */
  get allRequiredValid(): boolean {
    return !!this.form && this.firstInvalidStep() === -1;
  }

  /**
   * Navegação entre passos com gate no passo básico:
   *  - qualquer passo além do básico exige o básico 100% válido;
   *  - ao sair do básico pela primeira vez (modo criar), o projeto é criado
   *    sob demanda — só então os demais passos podem ser preenchidos.
   */
  async goToStep(index: number): Promise<void> {
    if (index < 0 || index >= this.steps.length || index === this.activeStep) return;

    // Trava: não sai do básico enquanto os obrigatórios não estiverem válidos.
    if (index > 0 && !this.validateStep(0)) {
      this.activeStep = 0;
      this.markStepDirty(0);
      this.showRequiredToast();
      return;
    }

    // Primeira saída do básico (modo criar): cria o projeto antes de avançar.
    if (index > 0 && !this.editMode && !this.projectID) {
      if (!(await this.ensureProjectCreated())) return;
    }

    this.activeStep = index;
  }

  prev(): void {
    this.goToStep(this.activeStep - 1);
  }

  /** Avança validando apenas o passo atual. */
  next(): void {
    if (!this.validateStep(this.activeStep)) {
      this.markStepDirty(this.activeStep);
      this.showRequiredToast();
      return;
    }
    this.goToStep(this.activeStep + 1);
  }

  /** Valida todos os controles do passo informado. */
  private validateStep(index: number): boolean {
    const step = this.steps[index];
    if (!step) return true;
    return step.fieldKeys.every((key) => {
      const ctrl = this.form.get(key);
      return !ctrl || ctrl.valid;
    });
  }

  /** Marca como dirty os controles inválidos de um passo (dispara o destaque visual). */
  private markStepDirty(index: number): void {
    const step = this.steps[index];
    if (!step) return;
    step.fieldKeys.forEach((key) => {
      const ctrl = this.form.get(key);
      if (ctrl && ctrl.invalid) {
        ctrl.markAsDirty();
        ctrl.updateValueAndValidity();
      }
    });
  }

  /** true se o passo tem algum controle inválido E dirty (usado pelo stepper). */
  stepHasError(index: number): boolean {
    const step = this.steps[index];
    if (!step) return false;
    return step.fieldKeys.some((key) => {
      const ctrl = this.form.get(key);
      return !!ctrl && ctrl.invalid && ctrl.dirty;
    });
  }

  /** true se todos os controles do passo são válidos. */
  stepIsComplete(index: number): boolean {
    return this.validateStep(index);
  }

  /**
   * Exibe ✓ no stepper apenas quando o passo tem conteúdo de verdade
   * (obrigatórios preenchidos / itens adicionados) — não apenas por estar "sem erro".
   */
  isStepDone(index: number): boolean {
    const step = this.steps[index];
    if (!step) return false;
    switch (step.key) {
      case "basic":
        // todos os obrigatórios do passo preenchidos
        return this.validateStep(index);
      case "equipment": {
        const arr = this.form.get("genericEquipments") as FormArray | null;
        return !!arr && arr.length > 0 && arr.valid;
      }
      case "images":
        return (this.project?.images?.length ?? 0) > 0;
      case "share":
        return (this.project?.sharedWith?.length ?? 0) > 0;
      default:
        return false;
    }
  }

  /** Índice do primeiro passo com controle inválido, ou -1. */
  private firstInvalidStep(): number {
    for (let i = 0; i < this.steps.length; i++) {
      if (!this.validateStep(i)) return i;
    }
    return -1;
  }

  private showRequiredToast(): void {
    this.translocoService
      .selectTranslate("inputRequired")
      .subscribe((value) => {
        this.messageService.clear();
        this.messageService.add({
          key: "toastRegisterProject",
          severity: "error",
          summary: value,
        });
      })
      .unsubscribe();
  }

  private showConnectionError(): void {
    this.translocoService
      .selectTranslateObject("error.connection")
      .subscribe((value) => {
        this.messageService.clear();
        this.messageService.add({
          key: "toastRegisterProject",
          severity: "error",
          summary: value.header,
          detail: value.message,
        });
      })
      .unsubscribe();
  }

  async openingDialog() {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      // userID só precisa ser buscado uma vez.
      if (!this.userID) {
        const userData = await this.accountService.findUserActive().toPromise();
        if (userData) {
          sessionStorage.setItem("nameUser", userData.name);
          sessionStorage.setItem("language", userData.language);
          this.userID = userData.userID;
        }
      }

      // Opções de referência são estáticas na sessão → carrega uma única vez.
      // Evita recarregar tudo (e duplicar categorias) a cada reabertura do modal.
      if (!this.optionsLoaded) {
        const [, , carList, applications, sharingTypes] = await Promise.all([
          this.FindUserVcus(this.userID),
          this.findCategories(),
          this.carManufactureService.getCarList().toPromise(),
          this.applicationService.getAllApplication().toPromise(),
          this.sharingProjectTypeService.getAllSharingProjectType().toPromise(),
        ]);

        this.carsManufactureOptions = carList ?? [];
        this.applicationOptions = ApplicationService.toItemList(
          applications ?? []
        );
        this.sharingProjectTypeOptions =
          SharingProjectTypeService.toSharingItemList(sharingTypes ?? []);
        this.optionsLoaded = true;
      }

      // Edição: carrega o projeto da rota (usa snapshot — sem acumular subscriptions).
      this.projectID = this.activatedRoute.snapshot.params["id"];
      if (this.editMode && this.userID && this.projectID) {
        this.isLoadingEquipments = true;
        try {
          const dataProject = await this.projectService
            .getProject(this.userID, this.projectID)
            .toPromise();
          if (dataProject) {
            this.project = ProjectService.toProject(dataProject);
          }
          if (this.project) {
            this.primaryImage = this.project.primaryImage;
            this.loadForm(this.project);
          }
        } catch (err) {
          console.error("Error fetching project data:", err);
        } finally {
          this.isLoadingEquipments = false;
        }
      }
    } catch (error) {
      console.error("Error in openingDialog:", error);
    }
  }

  loadForm(project: Project) {
    this.isLoadingEquipments = true;
    this.createForm(project);
    this.loadEquipment(project);
    this.isLoadingEquipments = false;
  }

  createForm(project: Project) {
    if (project.images.length > 0) {
      project.images.forEach((image) => {
        if (image.href && !image.size) {
          this.fetchImageSize(image);
        }
      });
    }
    if (project.primaryImage && project.images) {
      project.images.map((image) => {
        if (image.name === this.project?.primaryImage?.name) {
          image.primary = true;
        }
      });
    }
    this.project = project;
    this.selectedCarModel = project.vehicle?.model;

    this.form = this.formBuilder.group({
      name: [project.name, CustomValidator.getRequired()],
      application: [
        Array.isArray(project.application) && project.application.length > 0
          ? project.application[0]
          : null,
        CustomValidator.getRequired(),
      ],
      manufacturer: [
        typeof project.vehicle?.manufacturer === "string"
          ? { name: project.vehicle?.manufacturer }
          : project.vehicle?.manufacturer,
      ],
      model: [
        typeof project.vehicle?.model === "string"
          ? { name: project.vehicle?.model }
          : project.vehicle?.model,
      ],
      yearDate: [project.vehicle?.yearDate],
      tags: [project.tags],
      detail: [project.detail],
      genericEquipments: this.formBuilder.array([]),
      images: [project.images],
      primaryImage: [project.primaryImage],
      email: ["", CustomValidator.getEmailShare()],
      sharedWith: [project.sharedWith],
      favorite: [project.favorite],
      sharingProjectType: [
        project.sharingProjectType,
        CustomValidator.getRequired(),
      ],
      likes: [project.likes],
    });

    if (project.vehicle?.manufacturer) {
      const findModel = this.carsManufactureOptions.find(
        (model) => model.name === project.vehicle?.manufacturer
      );

      if (findModel) {
        let model = sessionStorage.getItem(findModel.name.toString());

        if (model) {
          this.carsModelOptions = JSON.parse(model) as CarsManufactureModel[];
        } else {
          this.getCarModels(findModel.name, findModel.code.toString());
        }
      }
    }
  }

  resetForm() {
    // this.form.reset();
    this.project = new Project();
    this.createForm(this.project);
    if (this.project) {
      this.project.sharedWith = [];
    }
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  /** Salva o projeto. Valida tudo e roteia ao primeiro passo com erro antes de enviar. */
  submit(): void {
    const invalid = this.firstInvalidStep();
    if (invalid !== -1) {
      this.goToStep(invalid);
      this.markStepDirty(invalid);
      this.showRequiredToast();
      return;
    }
    if (this.isClicked) return;
    this.isClicked = true;

    this.f.primaryImage.setValue(this.project?.primaryImage);
    this.f.sharedWith.setValue(this.project?.sharedWith);

    try {
    if (this.editMode) {
      this.loadingUpload = true;
      this.projectService
        .updateProject(
          this.userID,
          this.projectID,
          this.converterFormToUpdateProjectPutReq(this.form)
        )
        .subscribe({
          next: (project) => this.handleSaveResult(!!project, "putMessage"),
          error: () => {
            this.isClicked = false;
            this.loadingUpload = false;
          },
        });
    } else if (this.projectID) {
      // No modo criar o projeto pode já ter sido criado no upload de imagens → atualiza.
      this.projectService
        .updateProject(
          this.userID,
          this.projectID,
          this.converterFormToUpdateProjectPutReq(this.form)
        )
        .subscribe({
          next: (project) => this.handleSaveResult(!!project, "postMessage"),
          error: () => {
            this.isClicked = false;
          },
        });
    } else {
      this.projectService
        .createProject(
          this.userID,
          this.converterFormToCreateProjectPostReq(this.form)
        )
        .subscribe({
          next: (project) => {
            if (project) {
              this.projectID = project.projectID;
            }
            this.handleSaveResult(!!project, "postMessage");
          },
          error: () => {
            this.isClicked = false;
          },
        });
    }
    } catch (e) {
      console.error("submit error:", e);
      this.isClicked = false;
      this.loadingUpload = false;
      this.showConnectionError();
    }
  }

  /** Toast de sucesso/erro e fecha o modal em caso de sucesso. */
  private handleSaveResult(
    ok: boolean,
    msgKey: "postMessage" | "putMessage"
  ): void {
    this.isClicked = false;
    this.loadingUpload = false;
    if (ok) {
      this.translocoService
        .selectTranslateObject("project.register")
        .subscribe((value) => {
          this.messageService.clear();
          this.messageService.add({
            key: "toastRegisterProject",
            severity: "success",
            summary: value.header,
            detail: value[msgKey],
          });
        })
        .unsubscribe();
      // Sinaliza o save (com o id) ANTES de resetar — os pais recarregam só aqui.
      this.saved.emit(this.projectID);
      this.closeModal();
    } else {
      this.showConnectionError();
    }
  }

  /**
   * Garante um projectID antes do upload (modo criar): valida o passo básico e
   * cria o projeto sob demanda. Resolve false se abortar (obrigatório vazio ou erro).
   */
  private ensureProjectCreated(): Promise<boolean> {
    if (this.editMode || this.projectID) return Promise.resolve(true);
    // Guard de reentrância: se já há uma criação em andamento, reaproveita a mesma
    // promise em vez de disparar um segundo createProject. Evita projetos duplicados
    // quando o usuário clica "Próximo" duas vezes antes da 1ª resposta chegar.
    if (this.creatingProjectPromise) return this.creatingProjectPromise;
    if (!this.validateStep(0)) {
      this.goToStep(0);
      this.markStepDirty(0);
      this.showRequiredToast();
      return Promise.resolve(false);
    }
    this.creatingProject = true;
    this.creatingProjectPromise = new Promise<boolean>((resolve) => {
      this.projectService
        .createProject(
          this.userID,
          this.converterFormToCreateProjectPostReq(this.form)
        )
        .subscribe({
          next: (project) => {
            if (project) {
              this.projectID = project.projectID;
              resolve(true);
            } else {
              this.showConnectionError();
              resolve(false);
            }
          },
          error: () => {
            this.showConnectionError();
            resolve(false);
          },
        });
    }).finally(() => {
      this.creatingProject = false;
      this.creatingProjectPromise = null;
    });
    return this.creatingProjectPromise;
  }


  addGenericEquipment(type: string) {
    if (TypeEquipment.VCU.valueOf() === type) {
      const control = this.form.get("genericEquipments") as FormArray;
      control.push(
        this.formBuilder.group({
          vcu: [{}, CustomValidator.getRequired()],
        })
      );
    } else if (TypeEquipment.EQUIPMENT.valueOf() === type) {
      const control = this.form.get("genericEquipments") as FormArray;
      control.push(
        this.formBuilder.group({
          category: [{}, CustomValidator.getRequired()],
          product: [{}, CustomValidator.getRequired()],
        })
      );
    }
  }

  removeGenericEquipment(index: number) {
    const control = this.form.get("genericEquipments") as FormArray;
    control.removeAt(index);
  }

  getGenericEquipments() {
    return (this.form.get("genericEquipments") as FormArray).controls;
  }

  getGenericType(genericEquipment: any) {
    if (genericEquipment.vcu) return TypeEquipment.VCU.valueOf();
    else return TypeEquipment.EQUIPMENT.valueOf();
  }

  convertFileToImage(file: File | any) {
    this.idAux += 1;
    // return new Image(
    //   this.idAux,
    //   file.name,
    //   file.objectURL?.changingThisBreaksApplicationSecurity,
    //   file.size
    // );

    // Cria um objectURL seguro
    const objectUrl = URL.createObjectURL(file);
    const safeUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl);

    return new Image(
      this.idAux,
      file.name,
      safeUrl as unknown as string,   // agora é seguro usar no Angular
      file.size
    );
  }

  removeImage(image: File | any) {
    if (this.project) {
      let index = this.project.images.indexOf(image);
      this.project.images.splice(index, 1);
      if (
        image?.href === this.project.primaryImage?.href &&
        this.project.images.length > 0
      ) {
        this.project.primaryImage = this.project.images[0];
      }
    }
  }

  setPrimaryImage(selectedImage: any) {
    selectedImage.name = this.sanitizeFileName(selectedImage.name);
    this.primaryImage = selectedImage;
    this.project?.images.forEach((image) => (image.primary = false));
    selectedImage.primary = true;
    if (this.project) {
      this.project.primaryImage =  selectedImage.name;
    }
  }

  fetchImageSize(image: any) {
    fetch(image.href)
      .then((response) => response.blob())
      .then((blob) => {
        image.size = blob.size;
      })
      .catch((error) =>
        console.error("Erro ao obter tamanho da imagem:", error)
      );
  }

  addShare() {
    if (this.project && this.f.email.valid) {
      this.accountService.FindUserEmail(this.f.email.value).subscribe({
        next: (data) => {
          // this.userID = this.authService.getUserInformations()
          if (data.id != this.userID) {
            this.project!.sharedWith = [
              ...this.project!.sharedWith,
              new Share(data.id!, data.name!, this.f.email.value),
            ];
            this.f.email.setValue("");
          } else {
            this.translocoService
              .selectTranslateObject("project.register")
              .subscribe((value) => {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastRegisterProject",
                  severity: "error",
                  summary: value.header,
                  detail: value.equalEmail,
                });
              })
              .unsubscribe();
          }
        },
        error: (error) => {
          if (error.error === "USE-404") {
            this.translocoService
              .selectTranslateObject("project.register")
              .subscribe((value) => {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastRegisterProject",
                  severity: "error",
                  summary: value.header,
                  detail: value.user404,
                });
              })
              .unsubscribe();
          } else {
            this.translocoService
              .selectTranslateObject("project.register")
              .subscribe((value) => {
                this.messageService.clear();
                this.messageService.add({
                  key: "toastRegisterProject",
                  severity: "error",
                  summary: value.header,
                  detail: error.error,
                });
              })
              .unsubscribe();
          }
        },
      });
    } else {
      this.f.email.markAsDirty();
    }
  }

  removeShare(index: number) {
    this.project?.sharedWith.splice(index, 1);
  }

  closeModal() {
    // Reset completo do estado do modal
    this.resetForm();
    this.activeStep = 0;
    this.isClicked = false;
    this.loadingUpload = false;
    this.loadinFinishButton = false;
    this.selectedFiles = null;
    this.projectID = "";

    // Emite evento de fechamento
    this.closeDialog.emit(this.projectID);
  }

  FindUserVcus(userID: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.vcusOptions = [];
      const statusVcu = "AC,AP";
      this.accountService
        .FindUserVcus(userID, statusVcu)
        .subscribe((response) => {
          if (response)
            for (let element of response) {
              if (element.id) {
                let dto = new GenericEquipment(
                  TypeEquipment.VCU,
                  element.id,
                  element.nickname!,
                  "",
                  element.serial!
                );
                this.vcusOptions.push(dto);
              } else {
                let dto = new GenericEquipment(
                  TypeEquipment.VCU,
                  "",
                  element.nickname!,
                  "",
                  element.serial!
                );
                this.vcusOptions.push(dto);
              }
            }
          resolve(true);
        });
    });
  }

  converterFormToCreateProjectPostReq(form: FormGroup): CreateProjectPostReq {
    const formValue = form.value;
    let project: CreateProjectPostReq = new CreateProjectPostReq();
    if (formValue.application.id) {
      project.applicationID = formValue.application.id;
    }
    if (formValue.sharingProjectType.id) {
      project.sharingProjectTypeID = formValue.sharingProjectType.id;
    }
    if (formValue.name) {
      project.name = formValue.name;
    }
    if (formValue.favorite) {
      project.default = formValue.favorite;
    }
    project.attributes = {};
    if (formValue.yearDate) {
      project.attributes["date-of-manufacture"] = formValue.yearDate;
    }
    if (formValue.detail) {
      project.attributes["detail"] = formValue.detail;
    }
    if (formValue.manufacturer) {
      project.attributes["manufacturer"] =
        typeof formValue.manufacturer === "string"
          ? formValue.manufacturer
          : formValue.manufacturer.name;
    }
    if (formValue.model) {
      project.attributes["vehicle-model"] =
        typeof formValue.model === "string"
          ? formValue.model
          : formValue.model.name;
    }

    if (this.selectedFiles && this.selectedFiles.length > 0) {
      let fileName = "";
      let primary = "";
      // this.selectedFiles.forEach(file => {
      //   fileName = fileName + file.name + ',';
      // });
      if (this.project) {
        this.project?.images.forEach((file) => {
          fileName = fileName + file.name + ",";
          if (file.primary) {
            primary = file.name;
          }
        });
      }
      fileName = fileName.substring(0, fileName.length - 1);
      project.attributes["photo"] = fileName;
      project.attributes["primaryImage"] = primary;
    }

    project.tags = [];
    if (formValue.tags && Array.isArray(formValue.tags)) {
      project.tags = formValue.tags;
    }

    project.sharings = [];
    if (formValue.sharedWith && Array.isArray(formValue.sharedWith)) {
      for (let share of formValue.sharedWith) {
        let addShare = new CreProUserSharingPostReq();
        addShare.userID = share.id;
        addShare.Permission = "OR";
        project.sharings.push(addShare);
      }
    }

    project.vcus = [];
    project.equipmentIDs = [];
    if (
      formValue.genericEquipments &&
      Array.isArray(formValue.genericEquipments)
    ) {
      for (let equipment of formValue.genericEquipments) {
        if (equipment.vcu && equipment.vcu.serial) {
          let addVcu = new CreProVcuPostReq();
          addVcu.nickname = equipment.vcu.name;
          addVcu.serial = equipment.vcu.serial;
          project.vcus.push(addVcu);
        } else if (equipment.product && equipment.product.id) {
          project.equipmentIDs.push(Number(equipment.product.id));
        }
      }
    }

    return project;
  }

  converterFormToUpdateProjectPutReq(form: FormGroup): UpdateProjectPutReq {
    const formValue = form.value;
    let project: UpdateProjectPutReq = new UpdateProjectPutReq();

    if (formValue.application.id) {
      project.applicationID = formValue.application.id;
    }

    if (formValue.sharingProjectType.id) {
      project.sharingProjectTypeID = formValue.sharingProjectType.id;
    }

    if (formValue.name) {
      project.name = formValue.name;
    }
    if (formValue.favorite) {
      project.default = formValue.favorite;
    }
    project.attributes = {};
    if (formValue.yearDate) {
      project.attributes["date-of-manufacture"] = formValue.yearDate;
    }
    if (formValue.detail) {
      project.attributes["detail"] = formValue.detail;
    }
    if (formValue.manufacturer) {
      project.attributes["manufacturer"] =
        typeof formValue.manufacturer === "string"
          ? formValue.manufacturer
          : formValue.manufacturer.name;
    }
    if (formValue.model) {
      project.attributes["vehicle-model"] =
        typeof formValue.model === "string"
          ? formValue.model
          : formValue.model.name;
    }

    project.tags = [];
    if (formValue.tags && Array.isArray(formValue.tags)) {
      project.tags = formValue.tags;
    }

    project.sharings = [];
    if (formValue.sharedWith && Array.isArray(formValue.sharedWith)) {
      for (let share of formValue.sharedWith) {
        let addShare = new UpdProUserSharingPutReq();
        addShare.userID = share.id;
        addShare.permission = "OR";
        project.sharings.push(addShare);
      }
    }

    project.vcus = [];
    project.equipmentIDs = [];
    if (
      formValue.genericEquipments &&
      Array.isArray(formValue.genericEquipments)
    ) {
      for (let equipment of formValue.genericEquipments) {
        if (equipment.vcu && equipment.vcu.serial) {
          let addVcu = new CreProVcuPostReq();
          addVcu.nickname = equipment.vcu.name;
          addVcu.serial = equipment.vcu.serial;
          project.vcus.push(addVcu);
        } else if (equipment.product && equipment.product.id) {
          project.equipmentIDs.push(Number(equipment.product.id));
        }
      }
    }

    let fileName = "";
    let primary = "";

    if (this.project) {
      this.project?.images.forEach((file) => {
        fileName = fileName + file.name + ",";
        if (file.primary) {
          primary = file.name;
        }
      });
    }
    if (fileName.length > 0) {
      fileName = fileName.substring(0, fileName.length - 1);
    }
    project.attributes["primaryImage"] = primary;
    project.attributes["photo"] = fileName;
    this.selectedFiles = null;
    return project;
  }

  onDragOver(e: DragEvent): void {
    e.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(e: DragEvent): void {
    e.preventDefault();
    this.isDragging = false;
  }

  onDrop(e: DragEvent): void {
    e.preventDefault();
    this.isDragging = false;
    const files = e.dataTransfer?.files;
    if (files && files.length) {
      this.onSelectFile({ target: { files } } as unknown as Event);
    }
  }

  async onSelectFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const files = Array.from(input.files);
    // No drag & drop o "input" é sintético e não possui setter de value.
    if (input && "value" in input) input.value = "";

    const ALLOWED_IMAGE_EXTS = UPLOAD_RULES.projectPhoto.exts; // jpg/png/webp (sem SVG/tif) — política central
    const invalidType = files.find(f => {
      const ext = f.name.split('.').pop()?.toLowerCase() ?? '';
      return !ALLOWED_IMAGE_EXTS.includes(ext);
    });
    if (invalidType) {
      this.messageService.add({
        key: 'toastRegisterProject',
        severity: 'error',
        summary: this.translocoService.translate('project.register.upload.typeSummary', { '0': invalidType.name }),
        detail: this.translocoService.translate('project.register.upload.typeDetail', { '0': ALLOWED_IMAGE_EXTS.join(', ') }),
      });
      return;
    }

    const MAX_SIZE = UPLOAD_RULES.projectPhoto.maxBytes; // 15 MB — política central
    const oversized = files.filter(f => f.size > MAX_SIZE);
    if (oversized.length) {
      this.messageService.add({
        key: 'toastRegisterProject',
        severity: 'error',
        summary: this.translocoService.translate('project.register.upload.sizeSummary'),
        detail: this.translocoService.translate('project.register.upload.sizeDetail'),
      });
      return;
    }

    // Modo criar: garante que o projeto exista (o upload precisa de projectID).
    if (!(await this.ensureProjectCreated())) return;

    this.selectedFiles = files.map(file => {
      const sanitizedName = this.sanitizeFileName(file.name);
      return new File([file], sanitizedName, { type: file.type });
    });

    this.loadingUpload = true;
    for (const file of this.selectedFiles) {
      await this.uploadFileSequentially(file);


      this.loadingUpload = false;
    }
  }

  sanitizeFileName(fileName: string): string {
    let safeName = fileName.replace(/^.*[\\\/]/, '');   // remove diretórios
    safeName = safeName.replace(/\s+/g, '_');           // troca espaços por "_"
    safeName = safeName.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // remove acentos
    safeName = safeName.replace(/[^a-zA-Z0-9._-]/g, ''); // remove chars inválidos

    return safeName || fileName;
  }

   

  uploadFileSequentially(file: File): Promise<void> {
  return new Promise((resolve, reject) => {
    this.fileService
      .UploadFiles(file, "photo", this.userID, this.projectID ?? "", "")
      .then(
        (response) => {
          const status = response && "status" in response ? response.status : 0;
          if (status >= 200 && status < 300) {
            const image = this.convertFileToImage(file);
            this.project?.images.push(image);

            const hasPrimary = this.project?.images.some(img => img.primary);

            if (!hasPrimary) {
              this.setPrimaryImage(image);
            }

            resolve();
          } else if (status === 403) {
            this.messageService.clear();
            this.messageService.add({
              key: "toastRegisterProject",
              severity: "error",
              summary: this.translocoService.translate('messages.error.uploadFailed'),
              detail: this.translocoService.translate('messages.error.maxStorageReached'),
            });
            this.loadingUpload = false;
            reject();
          } else {
            this.messageService.clear();
            this.messageService.add({
              key: "toastRegisterProject",
              severity: "error",
              summary: this.translocoService.translate('common.labels.error'),
              detail: this.translocoService.translate('messages.error.uploadFailed'),
            });
            this.loadingUpload = false;
            reject();
          }
        },
        (err) => reject(err)
      )
      .catch((error) => {
        this.loadingUpload = false;
        reject(error);
      });
  });
}



  findCategories(): Promise<boolean> {
    return new Promise((resolve) => {
      let language = sessionStorage.getItem("language");
      if (!language) {
        language = "pt-br";
      }
      this.categoriesOptions = []; // evita duplicar categorias em recargas
      this.categoryService.FindCategories(language).subscribe((data) => {
        if (data)
          data.forEach((register) => {
            this.categoriesOptions.push({
              name: register.categoryName!,
              category: "",
              id: register.categoryID?.toString()!,
              type: TypeEquipment.EQUIPMENT,
              serial: "",
            });
          });
        resolve(true);
      });
    });
  }

  FindEquipments(categoryID: string, index: number) {
    let language = sessionStorage.getItem("language");
    if (!language) {
      language = "pt-br";
    }

    if (!this.productsOptions[index]) {
      this.productsOptions[index] = [];
    } else {
      this.productsOptions[index] = [];
    }

    this.categoryService
      .FindEquipments(language, Number(categoryID))
      .subscribe((data) => {
        const options = data.map(
          (register) =>
            new GenericEquipment(
              TypeEquipment.EQUIPMENT,
              register.equipmentID?.toString()!,
              register.equipmentName!,
              register.categoryName ?? "",
              ""
            )
        );
        this.productsOptions[index] = options;
      });
  }

  loadEquipment(project: Project) {
    const formArray = this.form.get("genericEquipments") as FormArray;

    project.vcus.forEach((vcu: Vcu) => {
      formArray.push(
        this.formBuilder.group({
          vcu: [
            new GenericEquipment(
              TypeEquipment.VCU,
              vcu.id,
              vcu.surname,
              "",
              vcu.serialNumber
            ),
            CustomValidator.getRequired(),
          ],
        })
      );
    });

    project.equipments.forEach((equipment: Equipment) => {
      this.FindEquipments(equipment.categoryID + "", formArray.length);
      formArray.push(
        this.formBuilder.group({
          category: [
            new GenericEquipment(
              TypeEquipment.EQUIPMENT,
              equipment.categoryID + "",
              equipment.categoryName,
              "",
              ""
            ),
            CustomValidator.getRequired(),
          ],
          product: [
            new GenericEquipment(
              TypeEquipment.EQUIPMENT,
              equipment.id + "",
              equipment.name,
              equipment.categoryName,
              ""
            ),
            CustomValidator.getRequired(),
          ],
        })
      );
    });
  }

  get f() {
    return this.form.controls;
  }

  getCarModels(name: string, code: string) {
    try {
      const cachedData = sessionStorage.getItem(name);
      if (cachedData) {
        this.carsModelOptions = JSON.parse(cachedData) as any[];
        const selectedModel = this.carsModelOptions.find(
          (carModel) => carModel.name === this.project?.vehicle?.model
        );
      } else {
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (key) {
            const item = sessionStorage.getItem(key);
            if (item) {
              try {
                const parsedItem = JSON.parse(item);
                if (
                  Array.isArray(parsedItem) &&
                  parsedItem.every(
                    (model: any) => "name" in model && "code" in model
                  )
                ) {
                  sessionStorage.removeItem(key);
                  break;
                }
              } catch {}
            }
          }
        }
        this.carManufactureService.getCarModels(code).subscribe({
          next: (data) => {
            this.carsModelOptions = data;
            const selectedModel = this.carsModelOptions.find(
              (carModel) => carModel.name === this.project?.vehicle?.model
            );
            sessionStorage.setItem(name, JSON.stringify(data));
          },
          error: (err) => {
            console.error("Error fetching car models:", err);
            this.carsModelOptions = [];
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);
      this.carsModelOptions = [];
    }
  }

  filterManufacturer(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    const query = (event.query ?? '').toLowerCase();

    for (
      let i = 0;
      i < (this.carsManufactureOptions as CarsManufactureModel[]).length;
      i++
    ) {
      const manufacturer = (
        this.carsManufactureOptions as CarsManufactureModel[]
      )[i];
      // Match em qualquer posição do nome — "Chevrolet" deve achar "GM - Chevrolet".
      if (manufacturer.name.toLowerCase().includes(query)) {
        filtered.push(manufacturer);
      }
    }

    this.filtredManufacturer = filtered;
  }

  filterModel(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    const query = (event.query ?? '').toLowerCase();

    for (let i = 0; i < this.carsModelOptions.length; i++) {
      const model = this.carsModelOptions[i];
      // Match em qualquer posição do nome — "Plus" deve achar "Onix Plus".
      if (model.name.toLowerCase().includes(query)) {
        filtered.push(model);
      }
    }

    this.filtredModel = filtered;
  }
}

export interface StepDef {
  key: "basic" | "equipment" | "images" | "share";
  label: string; // rótulo i18n já resolvido
  fieldKeys: string[]; // controles do form pertencentes ao passo (para validação)
}

export enum TypeEquipment {
  VCU = "vcu",
  EQUIPMENT = "equipment",
}

export class GenericEquipment {
  id: string;
  type: TypeEquipment;
  name: string;
  category: string;
  serial: string;

  constructor(
    type: TypeEquipment,
    id: string = "",
    name: string = "",
    category: string = "",
    serial: string = ""
  ) {
    this.id = id;
    this.type = type;
    this.name = name;
    this.category = category;
    this.serial = serial;
  }
}
